// extracted by mini-css-extract-plugin
export var active = "_id-2";
export var recordingDot = "_id-1";
export var recordingIndicator = "_id-0";